import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import AgreementsModal from 'pages/Events/Views/Common/Modals/AgreementsModal'
import { creationEventStore } from 'state/event/eventCreationStore'

const Agreements: React.FC = () => {
  const [agreementsModal, setAgreementsModal] = useState<boolean>(false)
  const { eventData, agreements, setAgreements } = creationEventStore(
    store => ({
      eventData: store.eventData,
      agreements: store.agreements,
      setAgreements: store.setAgreements,
    }),
  )

  return (
    <>
      <div onClick={() => setAgreementsModal(true)}>
        <IconsTextNavigation
          iconName="Checks"
          heading="Agreements"
          isCompleted={agreements.length > 0 ? true : false}
        />
      </div>

      {agreementsModal && (
        <AgreementsModal
          modalOpen={agreementsModal}
          setModalOpen={setAgreementsModal}
          type="event"
          entityId={eventData?._id}
          selectedAgreementsIds={agreements}
          setSelectedAgreementsIds={setAgreements}
        />
      )}
    </>
  )
}

export default Agreements
